__turbopack_context__.v({
  "actions": "EntityDetail-module__H09iza__actions",
  "avatar": "EntityDetail-module__H09iza__avatar",
  "avatarLetter": "EntityDetail-module__H09iza__avatarLetter",
  "content": "EntityDetail-module__H09iza__content",
  "grid": "EntityDetail-module__H09iza__grid",
  "header": "EntityDetail-module__H09iza__header",
  "label": "EntityDetail-module__H09iza__label",
  "name": "EntityDetail-module__H09iza__name",
  "row": "EntityDetail-module__H09iza__row",
  "section": "EntityDetail-module__H09iza__section",
  "sectionTitle": "EntityDetail-module__H09iza__sectionTitle",
  "value": "EntityDetail-module__H09iza__value",
  "valueMuted": "EntityDetail-module__H09iza__valueMuted",
});
